import {
  buildFetchModel
} from './model.common'
// 用户信息
export const UserInfoModel = buildFetchModel({
  url: 'auth/user',
  defaultMethod: 'GET',
  after: ['response.syncTime', 'response.default', 'response.checkErrno']
});

// 用户信息修改
export const UserUpdateModel = buildFetchModel({
  url: 'auth/user/update',
  defaultMethod: 'POST'
});

// 用户注册
export const UserRegisterModel = buildFetchModel({
  url: 'auth/user/register',
  defaultMethod: 'POST'
});

// 用户登录
export const UserLoginModel = buildFetchModel({
  url: 'auth/user/login',
  defaultMethod: 'POST'
});

// 退出登录
export const UserLogoutModel = buildFetchModel({
  url: 'auth/user/logout',
  defaultMethod: 'POST'
});

// 重置密码
export const UserForgetPwdModel = buildFetchModel({
  url: 'auth/user/password/reset',
  defaultMethod: 'POST'
});

//学校注册信息校验
export const UserRegistrationInformationCheckModel = buildFetchModel({
  url: 'school/auth/register/check',
  defaultMethod: 'POST'
});

//学校人员注册
export const UserSchoolRegistrationModel = buildFetchModel({
  url: 'school/auth/register',
  defaultMethod: 'POST'
});

//广告接口
export const AdvertisementSchoolModel = buildFetchModel({
  url: 'common/ads/list',
  defaultMethod: 'GET'
});



// WEBPACK FOOTER //
// ./src/model/AuthModel.js